// Module
var code = "<div class=\"vt-sidenav__loading-indicator\" data-ng-class=\"{ 'vt-sidenav__loading-active': sli.sidenavLD.get().show }\">\n    <md-progress-linear md-mode=\"indeterminate\"></md-progress-linear>\n    <span data-ng-if=\"sli.loadingText\" class=\"vt-sidenav__loading-text\">{{ sli.loadingText }}</span>\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/component/widget/sidenav/sidenav-loading-indicator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;